module.exports = __webpack_public_path__ + "img/logo-jjyh.1b451648.jpg";